import { CardHeader, styled, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';

export const ProjectHeader = styled(CardHeader)({
  padding: '0.5rem 1rem',
});

export const ProjectPreview = styled('div')(({ theme }) => ({
  height: '14rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.divider,
}));

export const ProjectDate = styled(Typography)({
  color: grey[600],
});

export const ProjectTitleContent = styled('div')({
  height: '4rem',
  marginBottom: '0.5rem',
});

export const ProjectTitle = styled(Typography)({
  margin: 0,
  overflow: 'hidden',
  wordBreak: 'break-word',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  '-webkit-line-clamp': '2',
  '-webkit-box-orient': 'vertical',
});
